type QueryWithLoading = { isLoading: boolean };

export const useIsLoading = (queries: QueryWithLoading[]) => {
  const isLoading = queries.some((q) => q.isLoading);

  return isLoading;
};
